import { render } from "./MainHeader-eng.vue?vue&type=template&id=74189ff5&scoped=true"
const script = {}

import "./MainHeader-eng.vue?vue&type=style&index=0&id=74189ff5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74189ff5"]])

export default __exports__